import { render, staticRenderFns } from "./GeneralDeed.vue?vue&type=template&id=ad387ec0&"
import script from "./GeneralDeed.vue?vue&type=script&lang=js&"
export * from "./GeneralDeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports